module.exports = __webpack_public_path__ + "img/Porsche-specs2-lnk-3.02b4587f.png";